import type { GridCard } from '@Components/BigBrowse/Model/Classes/GridCard';
import type { PlaneTypes } from '@Components/BigBrowse/Model/ModelTypes';
import { Assets } from '@Utils/AssetsStore';
import { Html } from '@react-three/drei';
import { observer } from 'mobx-react-lite';

type Props = {
  gridCard: GridCard<PlaneTypes.Card_MultiSection_Hero>;
};
export const MultiSectionHeroText = observer(function MultiSectionHeroText({
  gridCard,
}: Props) {
  const htmlStyle = {
    pointerEvents: 'none',
    width: gridCard.size.width,
    height: gridCard.size.height,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    color: 'white',
    cursor: 'default',
  };

  const wrapperStyle = {
    // drei Html component has an issue with padding, so we apply padding manually
    width: gridCard.size.width - 80,
    height: gridCard.size.height - 80,
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'flex-end',
  };

  const marginBottom =
    Boolean(gridCard.data?.title) && Boolean(gridCard.data?.body) ? 18 : 0;

  const titleStyle = {
    fontSize: 36,
    fontFamily: Assets.Font_Gilroy_Bold,
    lineHeight: 1.083333, // 36/33
    letterSpacing: 1.08, // 36 * 0.03
    marginBottom,
  };

  const bodyStyle = {
    fontSize: 18,
    fontFamily: Assets.Font_Gilroy_SemiBold,
    lineHeight: 1.22222, // 18/22
    letterSpacing: 0.54, // 18 * 0.03
  };

  return (
    // @ts-expect-error
    <Html style={htmlStyle} center zIndexRange={[0, 0]}>
      {/* @ts-expect-error*/}
      <div style={wrapperStyle}>
        <div style={titleStyle}>{gridCard.data?.title}</div>
        <div style={bodyStyle}>{gridCard.data?.body}</div>
      </div>
    </Html>
  );
});
